export const FaqsData = [
  {
    heading: "This Designer Bronzer Has Even Buyers Splurging!",
    para: ` Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3
    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum
    eiusmod. Brunch 3 wolf moon tempor.`
  },
  {
    heading: "4 Tips for A Colorful Easter Tablescape",
    para: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3
    wolf moon officia aute.`
  },
  {
    heading: "Hawaii Couples Trip Guide and Spring Break Faves",
    para: `assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred
    nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer
    farm-to-table, raw denim aesthetic.`
  },
  {
    heading: "If You Struggle To Hit Your Goals, Try This Instead",
    para: `Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer
    farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus
    labore sustainable VHS..`
  },
  {
    heading: "This Designer Bronzer Has Even Buyers Splurging!",
    para: ` Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3
    wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum
    eiusmod. Brunch 3 wolf moon tempor.`
  }
]